import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import "./styles/globals.css";
import { makeQueryClient } from "@/lib/api/query";
import { initI18n } from "@/lib/i18n";
import { registerSessionExpiryListener } from "@/lib/session/use-session";
import { initTheme } from "@/lib/theme";
import { enableMocking } from "@/mocks/browser";
import { createAppRouter } from "@/router";

initTheme();
initI18n();

async function bootstrap(): Promise<void> {
  // In mock mode the service worker must be live before the first query fires.
  await enableMocking();

  const queryClient = makeQueryClient();
  const router = createAppRouter(queryClient);
  registerSessionExpiryListener(queryClient, router);

  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Missing #root element — index.html is out of sync with main.tsx");
  }

  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
